import React, { useEffect, useState } from "react";
import SplitPane from "react-split-pane";
import UseToggle from "../../../Hooks/UseToggle";
import { Form, Table } from "react-bootstrap";
import { cdiscManagementService } from "../../../APIServices/CDISC/cdiscManagementService";
import { CiSearch } from "react-icons/ci";
import {
  NoDataFoundTable,
  PageLoader,
} from "../../../Components/NoDataFoundTable/NoDataFoundTable";
import AddNewFinalDomain from "./AddNewFinalDomain";
import Moment from "react-moment";
import { FaEdit, FaPlay } from "react-icons/fa";
import { FaTrash } from "react-icons/fa6";
import Pagination from "../../Pagination";
import Swal from "sweetalert2";
import DomainActivities from "./Properties/DomainActivities";
import TableProperties from "./Properties/TableProperties";
import UpdateFinalDomain from "./UpdateFinalDomain";
import DeletedDomainData from "./DeletedDomainData";
import { studyOnboardingService } from "../../../APIServices/studyOnboarding";
import { studyOtherSettingsServices } from "../../../APIServices/studyOtherSettingsServices";
import { useParams } from "react-router";
import ImportFinalDomainData from "./Properties/ImportFinalDomainData";

const FinalDomain = ({ onMouseDown, tableRef, setRunOutput }) => {
  const toggles = UseToggle();
  const { studyId } = useParams()
  const [loader, setLoader] = useState(false);
  const [runLoader, setRunLoader] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [finalDomain, setFinalDomain] = useState([]);
  const [finalDomainCount, setFinalDomainCount] = useState(0);
  const [domainData, setDomainData] = useState("");
  const [isFormOpen, setIsFormOpen] = useState("");
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [categoryId, setCategoryId] = useState("");
  const [activeTab, setActiveTab] = useState("activities");
  const [tableColumns, setTableColumns] = useState({});
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const [cdiscVersion, setCDISCVersion] = useState("");

  const getSingleStudies = async () => {
    const res = await studyOnboardingService.getSingleStudies(studyId);
    const data = res?.data?.[0] || {};
    setCDISCVersion(data.cdiscVersion || "");
  };

  const formColumn = [
    {
      columnLabel: "Target Domain Class",
      columnName: "CLASSNAME",
      columnType: "text",
    },
    {
      columnLabel: "Target Domain Label",
      columnName: "DOMAINLABEL",
      columnType: "text",
    },
    {
      columnLabel: "Target Domain Name",
      columnName: "DOMAINNAME",
      columnType: "text",
    },
    {
      columnLabel: "Target Domain Type",
      columnName: "DOMAINTYPE",
      columnType: "text",
    },
    {
      columnLabel: "Key",
      columnName: "KEYVARIABLE",
      columnType: "text",
    },
    {
      columnLabel: "Created Date | Time",
      columnName: "CREATED",
      columnType: "date & time",
    },
    {
      columnLabel: "Updated Date | Time",
      columnName: "UPDATED",
      columnType: "date & time",
    },
    { columnLabel: "Run", columnName: "RUN", columnType: "action" },
    { columnLabel: "Edit", columnName: "EDIT", columnType: "action" },
    { columnLabel: "Delete", columnName: "DELETE", columnType: "action" },
  ];

  const [pageNumber, setPageNumber] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const startIndex = (pageNumber - 1) * itemsPerPage;
  const totalPage = Math.ceil(finalDomainCount / itemsPerPage);

  const getCDISCStudyFinalDomain = async () => {
    setLoader(true);
    let data = await cdiscManagementService.getCDISCStudyFinalDomain(
      "active",
      studyId,
      searchData,
      pageNumber,
      itemsPerPage
    );
    setFinalDomain(data?.data || []);
    setFinalDomainCount(data?.count || 0);
    setLoader(false);
  };

  const downloadFinalDomainTemplate = async () => {
    let data = await cdiscManagementService.downloadFinalDomainTemplate();
    const csvContent = (data?.data || []).join(",") + "\n";
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Final-Domain-Template.csv";
    link.click();
  };

  useEffect(() => {
    getCDISCStudyFinalDomain();
  }, [searchData, pageNumber, itemsPerPage]);

  const updateClassNameModal = (item) => {
    setDomainData(item);
    toggles.setToggle();
  };

  const [pageNumberDeleted, setPageNumberDeleted] = useState(1);
  const [itemsPerPageDeleted, setItemsPerPageDeleted] = useState(10);
  const [deletedDomainCount, setDeletedDomainCount] = useState(0);
  const [deletedDomain, setDeletedDomain] = useState([]);

  const getDeletedDomainList = async () => {
    let data = await cdiscManagementService.getCDISCStudyFinalDomain(
      "deleted",
      studyId,
      "",
      pageNumberDeleted,
      itemsPerPageDeleted
    );
    setDeletedDomain(data?.data || []);
    setDeletedDomainCount(data?.count || 0);
  };

  const softDeleteRestoreCDISCStudyFinalDomains = async (id, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} domain!`,
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {};
        userData.id = id;
        userData.studyId = studyId;
        userData.type = type;
        let data = await cdiscManagementService.softDeleteRestoreCDISCStudyFinalDomains(
          userData
        );
        if (data?.statusCode === 200) {
          getCDISCStudyFinalDomain();
          getDeletedDomainList();
          setCategoryId("");
          if (type === "restore") {
            getCDISCStudyFinalDomain();
            getDeletedDomainList(pageNumberDeleted, itemsPerPageDeleted);
            toggles.setToggle1();
          }
        }
      }
    });
  };

  const [formActivity, setFormActivity] = useState([]);
  const [formActivityCount, setFormActivityCount] = useState(0);
  const [activityLoader, setActivityLoader] = useState(false);
  const [buttonLoader, setButtonLoader] = useState(false);

  const getStudyCDISCAuditTrials = async (pageNumber, itemsPerPage) => {
    setActivityLoader(true);
    let data = await studyOnboardingService.getStudyCDISCAuditTrials(
      "CDISCStudyFinalDomainMetadata",
      studyId,
      domainData?.domainId,
      StudyMode,
      pageNumber,
      itemsPerPage
    );
    setFormActivity(data?.data || []);
    setFormActivityCount(data?.count || 0);
    setActivityLoader(false);
  };

  const getGlobalTablePropertiesData = async (e) => {
    let data = await studyOtherSettingsServices.getGlobalTablePropertiesData(
      "CDISCStudyFinalDomainMetadata"
    );
    setTableColumns(data?.data || {});
  };

  useEffect(() => {
    getSingleStudies()
    getGlobalTablePropertiesData();
  }, []);

  const updateTableProperties = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to update table property!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, Update it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        setButtonLoader(true);
        let userData = {};
        userData.type = "CDISCStudyFinalDomainMetadata";
        userData.columns = tableColumns;
        let data = await studyOtherSettingsServices.updateTableProperties(
          userData
        );
        if (data?.statusCode === 200) {
          getCDISCStudyFinalDomain();
          getGlobalTablePropertiesData();
        }
      }
      setButtonLoader(false);
    });
  };

  const runCDISCFinalCode = async (id, sdtmDomain, domainclass) => {
    let userData = {}
    setRunLoader(id)
    userData.studyId = studyId
    userData.sdtmDomain = sdtmDomain
    userData.domainclass = domainclass
    userData.versionData = cdiscVersion
    userData.mode = StudyMode
    let data = await cdiscManagementService.runCDISCFinalCode(userData)
    if(data?.statusCode === 200){
      setRunOutput(Math.floor(1000000000 + Math.random() * 9000000000))
      setRunLoader("")
    }
  }

  return (
    <>
      <div
        className="justify-content-between toolbar border-bottom hstack p-1"
        style={{ height: 36 }}
      >
        <div className="hstack gap-1">
          <i
            title={isFormOpen ? "Close Form" : "Add Form Field Group Metadata"}
            onClick={() => {
              setIsFormOpen(!isFormOpen);
              setCategoryId("");
            }}
            className={`fa-solid ${isFormOpen ? "fa-table-list" : "fa-plus-square CP"
              }`}
          />
          <div className="vr"></div>
          {finalDomainCount > 0 && (
            <div className="position-relative">
              <Form.Control
                type="Search"
                onChange={(e) => setSearchData(e.target.value)}
                value={searchData}
                placeholder="Search..."
                style={{ width: 200, padding: "5px 10px" }}
              ></Form.Control>
              <CiSearch
                className="CP position-absolute bg-white"
                title="Search"
                style={{ width: 15, top: 5, right: 7 }}
              />
            </div>
          )}
        </div>
        <div className="hstack gap-2">
          <button
            onClick={() => toggles.setToggle4()}
            className={`updateProfile`}
            style={{ fontSize: 12 }}
          >
            Import
          </button>
          {finalDomainCount > 0 && (
            <button
              onClick={() => toggles.setToggle2()}
              className={`updateProfile`}
              style={{ fontSize: 12 }}
            >
              Table Properties
            </button>
          )}
          {deletedDomainCount > 0 && (
            <button
              onClick={() => toggles.setToggle1()}
              className={`updateProfile`}
            >
              Deleted History
            </button>
          )}
        </div>
      </div>
      <SplitPane
        split="horizontal"
        className="position-relative"
        style={{ height: "calc(100vh - 182px)" }}
        minSize={categoryId ? "40%" : "100%"}
      >
        <SplitPane
          split="vertical"
          minSize={20}
          className="position-relative"
          defaultSize={isFormOpen ? "20%" : "100%"}
        >
          {isFormOpen && <AddNewFinalDomain getCDISCStudyFinalDomain={getCDISCStudyFinalDomain} studyId={studyId} />}
          {loader ? (
            <PageLoader />
          ) : finalDomain?.length === 0 ? (
            <NoDataFoundTable MSG={"Domain data not found"} />
          ) : (
            <>
              <Table
                ref={tableRef}
                className="m-0 custom-table custom-tables"
                hover
                striped
              >
                <thead className="position-sticky top-0">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>

                    {!tableColumns["CLASSNAME"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 1)}>Target Domain Class</th>
                    )}

                    {!tableColumns["DOMAINLABEL"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 2)}>Target Domain Label</th>
                    )}

                    {!tableColumns["DOMAINNAME"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 3)}>Target Domain Name</th>
                    )}

                    {!tableColumns["DOMAINTYPE"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 4)}>Target Domain Type</th>
                    )}

                    {!tableColumns["KEYVARIABLE"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 5)}>Key Variable</th>
                    )}

                    {!tableColumns["CREATED"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 6)} style={{ width: 180 }}>
                        Created Date | Time
                      </th>
                    )}

                    {!tableColumns["UPDATED"] && (
                      <th onMouseDown={(e) => onMouseDown(e, 7)} style={{ width: 180 }}>
                        Updated Date | Time
                      </th>
                    )}
                    {!tableColumns["RUN"] && (
                      <th
                        onMouseDown={(e) => onMouseDown(e, 9)}
                        style={{ width: 55 }}
                        className="text-center"
                      >
                        Run
                      </th>
                    )}

                    {!tableColumns["EDIT"] && (
                      <th
                        onMouseDown={(e) => onMouseDown(e, 8)}
                        style={{ width: 55 }}
                        className="text-center"
                      >
                        Edit
                      </th>
                    )}

                    {!tableColumns["DELETE"] && (
                      <th
                        onMouseDown={(e) => onMouseDown(e, 9)}
                        style={{ width: 55 }}
                        className="text-center"
                      >
                        Delete
                      </th>
                    )}
                  </tr>
                </thead>

                <tbody>
                  {finalDomain?.map((item, index) => (
                    <tr
                      key={index}
                      onClick={() => {
                        setIsFormOpen(false);
                        setCategoryId(item?._id);
                        setDomainData(item);
                      }}
                      className={`CP ${categoryId === item?._id ? "highlighted" : ""}`}
                      title="View Details"
                    >
                      <td className="text-center">{startIndex + index + 1}</td>

                      {!tableColumns["CLASSNAME"] && <td>{item.targetDomainClass}</td>}
                      {!tableColumns["DOMAINLABEL"] && <td>{item.targetDomainLabel}</td>}
                      {!tableColumns["DOMAINNAME"] && <td>{item.targetDomainName}</td>}
                      {!tableColumns["DOMAINTYPE"] && (
                        <td className="text-capitalize">{item.targetDomainType}</td>
                      )}

                      {!tableColumns["KEYVARIABLE"] && (
                        <td>{item.key && item.key.join(", ")}</td>
                      )}

                      {!tableColumns["CREATED"] && (
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item.createdAt}
                          </Moment>
                        </td>
                      )}

                      {!tableColumns["UPDATED"] && (
                        <td>
                          <Moment format="DD MMM YYYY | HH:mm" withTitle>
                            {item.updatedAt}
                          </Moment>
                        </td>
                      )}

                      {!tableColumns["RUN"] && (
                        <td
                          className="text-center CP"
                          title="Update"
                          onClick={(e) => {
                            if (!runLoader) {
                              e.stopPropagation();
                              runCDISCFinalCode(item?._id, item?.targetDomainName, item?.targetDomainClass)
                            }
                          }}
                        >
                          {runLoader === item?._id ? <span className="CodeRunloader mt-2" title="Compiling"></span> : <FaPlay className="text-muted" />}
                        </td>
                      )}

                      {!tableColumns["EDIT"] && (
                        <td
                          className="text-center CP"
                          title="Update"
                          onClick={(e) => {
                            updateClassNameModal(item);
                            e.stopPropagation();
                          }}
                        >
                          <FaEdit className="text-muted" />
                        </td>
                      )}

                      {!tableColumns["DELETE"] && (
                        <td
                          className="text-center CP"
                          title="Delete"
                          onClick={(e) => {
                            softDeleteRestoreCDISCStudyFinalDomains(item._id, "delete");
                            e.stopPropagation();
                          }}
                        >
                          <FaTrash className="text-danger" />
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </Table>
              <div className="position-sticky bottom-0 start-0">
                <Pagination
                  totalPage={totalPage}
                  pageNumber={pageNumber}
                  itemsPerPage={itemsPerPage}
                  totalItems={finalDomainCount}
                  setPageNumber={setPageNumber}
                  setItemsPerPage={setItemsPerPage}
                />
              </div>
            </>
          )}
        </SplitPane>
        {categoryId && (
          <div className={isFullScreen ? "full-screen-component" : ""}>
            <div className="hstack paginate fixed_tab_button justify-content-between pt-1 border-bottom bg-light">
              <div className="hstack me-1 gap-1">
                {["activities"].map((tab) => (
                  <button
                    key={tab}
                    className={`buttonForTabs px-2 ${activeTab === tab ? "activee" : ""
                      }`}
                    onClick={() => setActiveTab(tab)}
                    title={tab.charAt(0).toUpperCase() + tab.slice(1)}
                  >
                    {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  </button>
                ))}
              </div>
              <div className="d-flex gap-1">
                <div className="toolbar">
                  <i
                    className="fa-solid fa-angle-down"
                    onClick={() => setCategoryId(false)}
                  ></i>
                </div>
                <div className="toolbar">
                  <i
                    className={`fa-solid me-2 ${!isFullScreen ? "fa-maximize" : "fa-minimize"
                      }`}
                    title={!isFullScreen ? "Full Mode" : "Original Mode"}
                    onClick={() => setIsFullScreen(!isFullScreen)}
                  ></i>
                </div>
              </div>
            </div>
            {activeTab === "activities" && (
              <DomainActivities
                tableRef={tableRef}
                onMouseDown={onMouseDown}
                formActivity={formActivity}
                activityLoader={activityLoader}
                formActivityCount={formActivityCount}
                getStudyCDISCAuditTrials={getStudyCDISCAuditTrials}
                domainData={domainData}
              />
            )}
          </div>
        )}
      </SplitPane>
      <TableProperties
        Show={!toggles.toggle2}
        Hide={toggles.setToggle2}
        Title={"Table Properties"}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        formColumn={formColumn}
        tableColumns={tableColumns}
        buttonLoader={buttonLoader}
        setTableColumns={setTableColumns}
        updateTableProperties={updateTableProperties}
      />
      <UpdateFinalDomain
        domainData={domainData}
        studyId={studyId}
        getCDISCStudyFinalDomain={getCDISCStudyFinalDomain}
        Show={!toggles.toggle}
        Hide={toggles.setToggle}
        Title={"Update Domain"}
      />
      <DeletedDomainData
        Show={!toggles.toggle1}
        Hide={toggles.setToggle1}
        setCategoryId={setCategoryId}
        tableRef={tableRef}
        onMouseDown={onMouseDown}
        deletedDomain={deletedDomain}
        getDeletedDomainList={getDeletedDomainList}
        deletedDomainCount={deletedDomainCount}
        pageNumberDeleted={pageNumberDeleted}
        itemsPerPageDeleted={itemsPerPageDeleted}
        setPageNumberDeleted={setPageNumberDeleted}
        setItemsPerPageDeleted={setItemsPerPageDeleted}
        softDeleteRestoreCDISCStudyFinalDomains={softDeleteRestoreCDISCStudyFinalDomains}
        Title={"Deleted Domain History"}
      />
      <ImportFinalDomainData
        Show={!toggles.toggle4}
        Hide={toggles.setToggle4}
        studyId={studyId}
        Title={"Import Final Domain Data"}
        getCDISCStudyFinalDomain={getCDISCStudyFinalDomain}
        downloadFinalDomainTemplate={downloadFinalDomainTemplate}
      />
    </>
  );
};

export default FinalDomain;
